import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res } from 'core/api';
import autoPrepareIfNeeded from '../utils/autoPrepareIfNeeded';
import * as SalesStore from '../SalesStore';
import { Command } from 'pos/common';
import { PrintFacade } from 'pos/facades';
import ShowPreviewScreen from 'pos/ui/ShowPreviewScreen';
import * as Images from 'pos/Images';
import { ticketCanBePrintedUnderMinRequiredAmount } from 'pos/modules/helpers/document-printing';
import { Message, Modal } from 'core/ui-next/modal';


async function printMultipleTickets(ticketIds: number[], flowMode: 'APPLY_TICKET_PRINTED_FLOW' | 'IGNORE_TICKET_PRINTED_FLOW'): Promise<Result> {
	if (SalesStore.isInitialized() && ticketIds.includes(SalesStore.getTicket().Id))
		await autoPrepareIfNeeded({ ticket: SalesStore.getTicket(), onTicketPrepared: ticket => SalesStore.loadTicketById(ticket.Id) });

	await SalesStore.printTickets(ticketIds, flowMode);

	return Result.ok();
}

async function printCurrentTicket(flowMode: 'APPLY_TICKET_PRINTED_FLOW' | 'IGNORE_TICKET_PRINTED_FLOW'): Promise<Result> {

	const ticket = SalesStore.getTicket();

	if (ticket.IsEmpty) {
		await Message.show(Res.Msg.MSG_TICKET_IS_EMPTY());
		return Result.error();
	}

	if (await ticketCanBePrintedUnderMinRequiredAmount(ticket) === false)
		return Result.error();

	const session = SessionProvider.getCurrent();

	if (!session.ShowTicketPreviewBeforePrint)
		return printMultipleTickets([ticket.Id], flowMode);

	const previews = await PrintFacade.getTicketPreviews(ticket.Id);
	return await Modal.show(ShowPreviewScreen, {
		title: Res.Web.TICKET_PREVIEW(),
		image: Images.PrintTicket,
		preview: previews[0],
		onPrint: () => { return printMultipleTickets([ticket.Id], flowMode); }
	});
}


declare global {
	interface CommandType {
		printCurrentTicket: (flowMode: 'APPLY_TICKET_PRINTED_FLOW' | 'IGNORE_TICKET_PRINTED_FLOW') => Promise<Result>;
		printMultipleTickets: (ticketIds: number[], flowMode: 'APPLY_TICKET_PRINTED_FLOW' | 'IGNORE_TICKET_PRINTED_FLOW') => Promise<Result>
	}
}

Command.register('printCurrentTicket', Preconditions.ensure(Permission.Ticket_PrintCopy), printCurrentTicket);
Command.register('printMultipleTickets', Preconditions.ensure(Permission.Ticket_PrintCopy), printMultipleTickets);